import { render, staticRenderFns } from "./SaleBlock.vue?vue&type=template&id=2d093a02&scoped=true"
import script from "./SaleBlock.vue?vue&type=script&lang=js"
export * from "./SaleBlock.vue?vue&type=script&lang=js"
import style0 from "./SaleBlock.vue?vue&type=style&index=0&id=2d093a02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d093a02",
  null
  
)

export default component.exports